import { Currency } from '@commenda/prisma';

export const CURRENCY_VS_SYMBOL_MAP = {
  [Currency.INR]: '₹',
  [Currency.USD]: '$',
  [Currency.SGD]: 'S$',
  [Currency.GBP]: '£',
};
